module.exports = __webpack_public_path__ + "img/video.a8953ec2.png";